export function mountStudioTickers(root = document) {
	root.querySelectorAll("[data-studio-ticker]").forEach(element => {
		if (element.dataset.mounted) return;
		element.dataset.mounted = "true";
		new StudioTicker(element);
	});
}

class StudioTicker {
	constructor(element) {
		this.window = element.querySelector(".studio-ticker__window");
		this.track = element.querySelector(".studio-ticker__track");
		[this.first, this.second] = this.track.children;
		this.seed = [...this.first.children].map(child => child.cloneNode(true));
		this.observer = new ResizeObserver(() => this.fill());
		this.observer.observe(this.window);
		this.fill();
		document.fonts?.ready.then(() => this.fill());
	}

	fill() {
		const width = this.window.clientWidth;
		if (!width || !this.seed.length) return;
		this.first.replaceChildren(...this.seed.map(child => child.cloneNode(true)));
		// Each half must fill the viewport so the loop never exposes an empty tail.
		while (this.first.getBoundingClientRect().width < width) {
			this.first.append(...this.seed.map(child => {
				const clone = child.cloneNode(true);
				clone.setAttribute("aria-hidden", "true");
				return clone;
			}));
		}
		this.second.replaceChildren(...[...this.first.children].map(child => child.cloneNode(true)));
		this.track.style.setProperty("--studio-ticker-duration", `${this.first.getBoundingClientRect().width / 42}s`);
	}
}
